import { Box, Divider, Text, VStack, HStack, Link } from '@chakra-ui/react'

export const Footer = () => {
  const contact = {
    heading: "Contact Information",
    address: "1503 S Watkins Road Watkins, CO 80137",
    phoneOne: "Clubhouse: 303-366-6970",
    phoneTwo: "Range Info Line: 303-512-9742",
    email: "pro-shop@goldengunclub.us"
  };

  const hours = {
    heading: "Hours of Operation",
    seasons: [
      {
        label: "Spring, Summer, Fall Hours (During Daylight Savings)",
        lines: [
          "Monday & Tuesday – Closed",
          "Wednesday & Thursday 10:00 a.m. to 7:00 p.m.",
          "Friday, Saturday & Sunday 10:00 a.m. to 5:00 p.m.",
        ],
      },
      {
        label: "Winter Hours (During Standard Time)",
        lines: [
          "Monday & Tuesday – Closed",
          "Wednesday thru Sunday 10:00 a.m. to 5:00 p.m.",
        ],
      },
    ],
    note: "HOLIDAY HOURS - the clubhouse will be closed on Christmas and New Years Day"
  };

  return (
    <Box mt={4} p="24px 0" px={{ base: '42px', md: '84px' }}>
      <Divider />
      <Box pt={6}>
        <HStack align="flex-start" spacing={8} flexWrap="wrap">
          <VStack align="flex-start" spacing={2} flex={1} minW="200px">
            <Box fontWeight="600">{contact.heading}</Box>
            <Box>{contact.address}</Box>
            <Box>{contact.phoneOne}</Box>
            <Box>{contact.phoneTwo}</Box>
            <Box><Link href={`mailto:${contact.email}`}>{contact.email}</Link></Box>
          </VStack>
          <VStack align="flex-start" spacing={4} flex={1} minW="200px">
            <Box fontWeight="600">{hours.heading}</Box>
            {hours.seasons.map((season) => (
              <VStack key={season.label} align="flex-start" spacing={1}>
                <Box fontWeight="600" fontSize="sm">{season.label}</Box>
                {season.lines.map((line) => (
                  <Box key={line}>{line}</Box>
                ))}
              </VStack>
            ))}
            <Box fontSize="sm" fontStyle="italic" color="gray.600">
              {hours.note}
            </Box>
          </VStack>
        </HStack>
        <Text pt={4} fontSize="sm" color="gray.600">© 2023 by Golden Gun Club.</Text>
      </Box>
    </Box>
  );
};
